module.exports = __webpack_public_path__ + "img/gift-vanguards.f4a5cba.png";